import { memo } from "react";

const URSSAFIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.49999 15.8333V4.74999C2.49994 4.57893 2.55253 4.412 2.65063 4.27186C2.74873 4.13172 2.88757 4.02516 3.04832 3.96666L11.1075 1.03666C11.1704 1.01375 11.238 1.00635 11.3044 1.01511C11.3708 1.02386 11.4342 1.04849 11.489 1.08693C11.5439 1.12536 11.5887 1.17646 11.6196 1.23589C11.6505 1.29532 11.6667 1.36133 11.6667 1.42833V5.55583L16.93 7.30999C17.096 7.36529 17.2404 7.47143 17.3427 7.61337C17.445 7.75531 17.5 7.92586 17.5 8.10083V15.8333H19.1667V17.5H0.833321V15.8333H2.49999ZM4.16665 15.8333H9.99999V3.21249L4.16665 5.33416V15.8333ZM15.8333 15.8333V8.70166L11.6667 7.31249V15.8333H15.8333Z"
      fill="currentColor"
    />
  </svg>
);

export default memo(URSSAFIcon);
